// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"a5a9371d","791":"4fe0c6cd"}[chunkId] + ".chunk.js";
};